<template>
  <b-container id="structure">
    <div id="alerts" ref="alert">
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
        >You have successfully added a structure record!</b-alert
      >
      <b-alert :show="formError" dismissible variant="warning">
        Something went wrong. Please refresh and try again, or contact the site
        admin.
      </b-alert>
    </div>
    <b-row>
      <b-button
        class="mx-auto m-4"
        variant="primary"
        v-if="showButton && isAdmin || isSRC"
        @click="(showForm = true), (showButton = false)"
        >Add Structure Record</b-button
      >
    </b-row>
    <div class="structureform m-2" v-if="showForm">
      <b-row>
        <b-col cols="5"></b-col>
        <b-col sm="3">
          <b-form-group label="Date">
            <b-form-input
              name="date"
              type="date"
              id="date"
              v-model="structure.date"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="5"></b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <div class="m-4">
              <label for="no-building" class="form-line"
                >Outdoor / Under a Tree:</label
              >
              <b-form-radio-group
                v-model="structure.outdoor"
                name="no-building"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="tin-shack" class="form-line">Tin Shack:</label>
              <b-form-radio-group
                v-model="structure.tin_shack"
                name="tin-shack"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="brick-buildings" class="form-line"
                >Brick Buildings:</label
              >
              <b-form-radio-group
                v-model="structure.brick_buildings"
                name="brick-buildings"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="mud-buildings" class="form-line"
                >Mud Buildings:</label
              >
              <b-form-radio-group
                v-model="structure.mud_buildings"
                name="mud-buildings"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="classroom-count" class="form-line"
                >Number of Classrooms:</label
              >
              <br />
              <b-form-input
                name="classroom-count"
                class="form-line"
                type="number"
                id="classroom-count"
                v-model="structure.classroom_count"
              ></b-form-input>
            </div>
            <div class="m-4">
              <label for="classroom-quality" class="form-line"
                >Is the number of classrooms sufficient?</label
              >
              <b-form-radio-group
                v-model="structure.classroom_count_sufficient"
                name="classroom-quality"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="running-water" class="form-line"
                >Running Water:</label
              >
              <b-form-radio-group
                v-model="structure.running_water"
                name="running-water"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="tippy-tap" class="form-line">Tippy Tap:</label>
              <b-form-radio-group
                v-model="structure.tippy_tap"
                name="tippy-tap"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="water-bucket" class="form-line"
                >Bucket of Water:</label
              >
              <b-form-radio-group
                v-model="structure.bucket_of_water"
                name="water-bucket"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="no-water" class="form-line">No Water:</label>
              <b-form-radio-group v-model="structure.no_water" name="no-water">
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="flushing-toilet" class="form-line"
                >Flushing Toilet:</label
              >
              <b-form-radio-group
                v-model="structure.flushing_toilet"
                name="flushing-toilet"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div class="m-4">
              <label for="pit-toilet" class="form-line">Pit Toilet:</label>
              <b-form-radio-group
                v-model="structure.pit_toilet"
                name="pit-toilet"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="male-female-toilet" class="form-line"
                >Separate Male / Female Toilets:</label
              >
              <b-form-radio-group
                name="male-female-toilet"
                type="text"
                id="male-female-toilet"
                v-model="structure.male_female_toilet"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="no-toilet" class="form-line">No Toilet:</label>
              <b-form-radio-group
                name="no-toilet"
                type="text"
                id="no-toilet"
                v-model="structure.no_toilet"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="no-tables" class="form-line"
                >No Tables / Chairs:</label
              >
              <b-form-radio-group
                name="no-tables"
                type="text"
                id="no-tables"
                v-model="structure.no_tables_chairs"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="some-tables-chairs" class="form-line"
                >Some Tables / Chairs:</label
              >
              <b-form-radio-group
                name="some-tables-chairs"
                type="text"
                id="some-tables-chairs"
                v-model="structure.some_tables_chairs"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="sufficient-tables-chairs" class="form-line"
                >Sufficient Tables / Chairs:</label
              >
              <b-form-radio-group
                name="sufficient-tables-chairs"
                type="text"
                id="sufficient-tables-chairs"
                v-model="structure.sufficient_tables_chairs"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="no-teaching-materials" class="form-line"
                >No Teaching Materials:</label
              >
              <b-form-radio-group
                name="no-teaching-materials"
                type="text"
                id="no-teaching-materials"
                v-model="structure.no_teaching_materials"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="some-teaching-materials" class="form-line"
                >Some Teaching Materials:</label
              >
              <b-form-radio-group
                name="some-teaching-materials"
                type="text"
                id="some-teaching-materials"
                v-model="structure.some_teaching_materials"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="sufficient-teaching-materials" class="form-line"
                >Sufficient Teaching Materials:</label
              >
              <b-form-radio-group
                name="sufficient-teaching-materials"
                type="text"
                id="sufficient-teaching-materials"
                v-model="structure.sufficient_teaching_materials"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="rural" class="form-line">Rural:</label>
              <b-form-radio-group
                name="rural"
                type="text"
                id="rural"
                v-model="structure.rural"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="m-4">
              <label for="urban" class="form-line">Urban:</label>
              <b-form-radio-group
                name="urban"
                type="text"
                id="urban"
                v-model="structure.urban"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </div>
            <br />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-button class="mx-auto m-4" variant="primary" @click="addOrUpdate">
          {{ buttonTitle }}
        </b-button>
      </b-row>
    </div>
    <b-row v-if="structureTable">
      <b-col>
        <div id="structure-table">
          <b-table
            v-cloak
            responsive
            small
            :fields="fields"
            :items="structureTable"
            :striped="true"
            :bordered="true"
            :hover="true"
            stacked="md"
            :filter="filter"
            :current-page="currentPage"
            @filtered="onFiltered"
            :per-page="perPage"
            id="financing-table"
          >
            <template slot="cell(id)" slot-scope="row">
              <b-link v-if="isAdmin || isSRC" @click.stop="editSchoolStructure(row)"
                >Edit</b-link
              >
            </template>
            <template slot="cell(delete)" slot-scope="row">
              <b-link
                class="delete"
                v-if="isAdmin || isSRC"
                @click.stop="deleteSchoolStructure(row.item.id)"
                >DELETE</b-link
              >
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SchoolService from "../services/SchoolService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "SchoolStructure",
  mixins: [flash, scrollTo],
  data() {
    return {
      structure: {
        id: null,
        school_uuid: this.$route.params.id,
        date: "",
        outdoor: false,
        tin_shack: false,
        mud_buildings: false,
        brick_buildings: false,
        classroom_count: 0,
        classroom_count_sufficient: false,
        running_water: false,
        tippy_tap: false,
        bucket_of_water: false,
        no_water: false,
        flushing_toilet: false,
        pit_toilet: false,
        male_female_toilet: false,
        no_toilet: false,
        no_tables_chairs: false,
        some_tables_chairs: false,
        sufficient_tables_chairs: false,
        no_teaching_materials: false,
        some_teaching_materials: false,
        sufficient_teaching_materials: false,
        rural: false,
        urban: false,
      },
      showForm: false,
      showButton: true,
      filter: "",
      totalRows: this.rows,
      currentPage: 1,
      perPage: 20,
      formError: false,
      disabled: false,
      required: false,
      changeTitle: false,
      fields: [
        { key: "struct_date", label: "Date", sortable: true },
        { key: "outdoor", label: "Outdoor", sortable: true },
        { key: "classroom_count", label: "Classroom Count", sortable: true },
        { key: "no_water", label: "No Water?", sortable: true },
        { key: "no_toilet", label: "No Toilet?", sortable: true },
        {
          key: "sufficient_teaching_materials",
          label: "Sufficient Teaching Materials",
          sortable: true,
        },
        { key: "id", label: "Edit" },
        { key: "delete", label: "Delete" },
      ],
    };
  },
  methods: {
    ...mapActions({
      GET_STRUCTURES: "schools/GET_SCHOOL_STRUCTURES",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async addSchoolStructure() {
      if (this.structure.date === null) {
        this.formError = true;
        this.flashError();
        return;
      }
      const data = this.structure;
      await delete data.id;
      await delete data.struct_date;
      await SchoolService.addSchoolStructure(data);
      await this.scrollTo("alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      await this.GET_STRUCTURES();
    },
    async updateSchoolStructure() {
      if (this.structure.date === null) {
        this.formError = true;
        this.flashError();
        return;
      }
      const data = this.structure;
      await delete data.struct_date;
      await SchoolService.updateSchoolStructure(data);
      await this.scrollTo("alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      this.showForm = false;
      this.showButton = true;
      await this.GET_STRUCTURES();
    },
    async addOrUpdate() {
      if (this.buttonTitle === "Edit Structure Record") {
        this.updateSchoolStructure();
      } else {
        this.addSchoolStructure();
      }
    },
    async deleteSchoolStructure(params) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this structure record?"
      );
      if (confirmDelete) {
        await SchoolService.deleteSchoolStructure(params);
        await this.GET_STRUCTURES();
      }
    },
    clearForm() {
      this.structure = {
        id: null,
        school_uuid: this.$route.params.id,
        date: "",
        outdoor: false,
        tin_shack: false,
        mud_buildings: false,
        brick_buildings: false,
        classroom_count: 0,
        classroom_count_sufficient: false,
        running_water: false,
        tippy_tap: false,
        bucket_of_water: false,
        no_water: false,
        flushing_toilet: false,
        pit_toilet: false,
        male_female_toilet: false,
        no_toilet: false,
        no_tables_chairs: false,
        some_tables_chairs: false,
        sufficient_tables_chairs: false,
        no_teaching_materials: false,
        some_teaching_materials: false,
        sufficient_teaching_materials: false,
        rural: false,
        urban: false,
      };
    },
    editSchoolStructure(row) {
      this.showForm = true;
      this.showButton = false;
      this.changeTitle = true;
      const date = row.item.struct_date;
      this.structure = row.item;
      this.structure.date = date;
      this.structureTable.splice(row.index, 1);
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    buttonTitle() {
      return this.changeTitle
        ? "Edit Structure Record"
        : "Add Structure Record";
    },
    structureTable: {
      get() {
        return this.$store.state.schools.structures;
      },
    },
    rows() {
      if (this.structureTable) {
        return this.structureTable.length;
      }
    },
  },
  created() {
    this.GET_STRUCTURES();
  },
};
</script>

<style scoped>
.form-line {
  display: inline;
}
label {
  font-weight: 500;
}
</style>
